// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import StopFilledSvg from "@fishx/icons-svg/es/asn/StopFilled";
import FishxIcon from '../components/FishxIcon';

var StopFilled = function StopFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: StopFilledSvg
  }));
};

StopFilled.displayName = 'StopFilled';
export default React.forwardRef(StopFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/StopFilled.js
// module id = 4202
// module chunks = 0